import { render } from "./RiverList.vue?vue&type=template&id=1cf5f383&scoped=true"
import script from "./RiverList.vue?vue&type=script&lang=js"
export * from "./RiverList.vue?vue&type=script&lang=js"

import "./RiverList.vue?vue&type=style&index=0&id=1cf5f383&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cf5f383"]])

export default __exports__